Dom.addComponent(new class ButtonComponent extends AbstractComponent {

  constructor() {
    super({
      name: "button",
      iframable: false,
      responsiveChildren: {
        width: false,
        height: false
      }
    });
  }

  css() {
    return `GULP-CSS-FILE-BUTTON`;
  }

  html(props) {
    let classes = `${props.sideClass} ${props.hideButtonClass} ${props.slaaskMiniClass}`.replace(/ +/g, " ").trim();
    return `
      <div class="${classes}" style="font-size: ${props.buttonSize}px; background-color: ${this.app._window_color}; color: ${this.app._title_color};" role="button" tabindex="0" aria-label="${props.slaaskMiniClass.includes('slaask-opened') ? Wording.close_chatbox : Wording.open_chatbox}">
        <style>
          .slaask-button .slaask-pulsing-button span::after, .slaask-button .slaask-pulsing-button span::before {
            background-color: ${Utils.alphaHex(this.app._window_color, .2)};
          }
        </style>
        ${props.buttonPulsing}
        <ul id="messages-counter" class="slaask-hidden">
          <li id="messages-counter-first">1</li>
          <li id="messages-counter-last">2</li>
        </ul>
        <div id="slaask-button-image" class="slaask-button-image" style="${props.buttonStyle}"></div>
        <div id="slaask-button-cross" class="slaask-button-cross" style="background-color: ${this.app._window_color};">
          ${Svg.cross(this.app._title_color, 48)}
        </div>
      </div>
    `;
  }

});
